export default "__VITE_ASSET__FfYhARuk__"